import React, { Component } from 'react';
import _ from 'lodash';
import { Row, Tabs, Col, Card, Avatar, notification, Spin, message, Tooltip, Rate, Select, Table} from 'antd';
import {GymImage,LeftChevronIcon,BadgeFirstIcon} from '../../assets/images';
import Highcharts from 'highcharts';
import Highstock from 'highcharts/highstock';
import ReactHighcharts from 'react-highcharts';
import { withDsChartTheme } from './../../utils/chartTheme';
import { Breadcrumb } from '../common/atoms';
const Charts = withDsChartTheme(ReactHighcharts.withHighcharts(Highstock));
const { Meta } = Card;
const TabPane = Tabs.TabPane;
const { Option } = Select;

class Trends extends Component {
  constructor(props) {
      super(props);
      this.state = {
        loading: false,
        data: {},
        dropdownValue: "last_30_days",
        employeeCountOverall: {filters:[], config: {}},
        baseConfig : {
          filters: [],
          config: {
            chart: {},
            title: {text: '', align: 'left'},
            subtitle: { text: '', align: 'left' },
            xAxis: {},
            yAxis: {},
            credits: {
              enabled: false
            },
            series: []
          }
        }
      };
  } 

  componentDidMount () {
    let that = this;
    this.setState({loading: true})
    window.axios.get(window.API_URL + 'corporate/gyms-trends')
      .then(function (response) {
        console.log(response.data)
        that.setState({ 
                       loading: false,
                       data: response.data})
      })
      .catch(function (error) {
        that.setState({loading: false})
        notification['error']({
        message: 'Something Went Wrong',
        description: "Please try again later"
        })
        console.log(error);
      })
  }

  renderOverview(){
    sessionStorage.setItem('defaultSelectedTab', '9')
    this.props.history.push({pathname: '/overview'})
  }

  handleChange(e){
    let that = this
    that.setState({dropdownValue: e})
  }

  renderChartTrends(){
    let that = this
    let a = that.state.dropdownValue
    if(a === "last_30_days"){
      return(
        <div>
          {this.renderDaysChart(that.state.data[a],a)}
        </div>
      )
    }else{
      return(
        <div>
          {this.renderChart(that.state.data[a],a)}
        </div>
      )
    }    
  }

  renderChart(record,dv){
    let that = this
    let keys = Object.keys(record)
    let baseConfig = _.cloneDeep(that.state.baseConfig)
    let series = Object.values(record)
    let text = ""
    if (dv === "last_30_days"){
      text = "last 30 days"
    }else if(dv === "last_12_months"){
      text = "last 12 months"
    }else if(dv === "last_year"){
      text = "last year"
    }else if(dv === "overall"){
      text = "lifetime"
    }
    baseConfig.config.chart.type = 'line'
    baseConfig.config.yAxis.title = {text: "Gyms and Fitness sessions count"}
    baseConfig.config.yAxis.allowDecimals = false 
    baseConfig.config.xAxis = {categories: keys
                              }                             
    baseConfig.config.plotOptions = {line: {dataLabels: { enabled: false},enableMouseTracking: true,events: {
            legendItemClick: function () {
                return false; 
            }
        }}}
     
    baseConfig.config.series = [{name: 'Booking Sessions Count',data: series.map(Number),color: '#2563EB',color1: '#ffffff'}]
    return(
      <div style={{marginTop: 30}}>
        <Charts 
          config={baseConfig.config}/>
        <Row style={{marginLeft: 0,marginTop: 30,marginBottom: 0}}>
          <Col span={12}>
            <Row type="flex" justify="start">
              <h4 className="sub-heading-title" style={{color: '#6B7280',marginLeft: 5}}>SESSIONS COUNT DISTRIBUTION BY</h4>
            </Row>
          </Col>
          <Col span={12}>
            <Row type="flex" justify="end">
              <h6 style={{color: '#6B7280',fontSize: 14}}>Showing data for <span className="semibold" style={{color: '#475569'}}>{text} </span></h6>
            </Row>  
          </Col>
        </Row>  
        
        <Row>
          <Col span={24}>
            <Tabs defaultActiveKey="1" >
              <TabPane tab="Workout" key="1">
                {this.renderWorkoutChartTrends(dv,'workout')}
              </TabPane>
              <TabPane tab="Locality" key="2">
                {this.renderWorkoutChartTrends(dv,'locality')}
              </TabPane>
              <TabPane tab="Week day" key="3">
                {this.renderWorkoutChartTrends(dv,'weekday')}
              </TabPane>
            </Tabs>  
          </Col>
        </Row> 
          
      </div>
    )
  }

  renderWorkoutChartTrends(e,text){
    let that = this
    let a = text + '_' + e
    return(
      <div>  
        {this.renderTabWiseChart(that.state.data[a])}
      </div>
    )
  }

  renderTabWiseChart(record){
    let that = this
    let keys = Object.keys(record)
    let baseConfig = _.cloneDeep(that.state.baseConfig)
    let series = Object.values(record)
    baseConfig.config.chart.type = 'column'
    baseConfig.config.yAxis.title = {text: "Sessions Count"}
    baseConfig.config.yAxis.allowDecimals = false 
    baseConfig.config.xAxis = {categories: keys
                              } 
                             
    baseConfig.config.plotOptions = {column: {dataLabels: { enabled: false},enableMouseTracking: true,events: {
            legendItemClick: function () {
                return false; 
            }
        }},
        series: {pointWidth: 10,dataLabels: {enabled: true,format: '{point.y:.0f}'}}}
     
    baseConfig.config.series = [{name: 'Sessions Count',data: series.map(Number),color: '#2563EB',color1: '#ffffff'}]
    return(
      <div style={{marginTop: 20}}>
        <Card className="health-check-utilization-card" style={{marginBottom: 20,marginTop: 10}}>
        <Charts 
          config={baseConfig.config} style={{marginTop: 30}}/> 
        </Card>  
      </div>
    )
  }

  renderDaysChart(record,dv){
    let that = this
    let baseConfig = _.cloneDeep(that.state.baseConfig)
    let text = ""
    if (dv === "last_30_days"){
      text = "last 30 days"
    }else if(dv === "last_12_months"){
      text = "last 12 months"
    }else if(dv === "last_year"){
      text = "last year"
    }else if(dv === "overall"){
      text = "lifetime"
    }
    baseConfig.config.chart.type = 'line'
    baseConfig.config.xAxis = {type: 'datetime',
                              dateTimeLabelFormats: {
                                  month: '%d. %b',
                                  year: '%b'
                                }
                              }                            
    baseConfig.config.yAxis.title = {text: "Gyms and Fitness sessions count"}  
    baseConfig.config.yAxis.allowDecimals = false                     
    baseConfig.config.plotOptions = {line: {dataLabels: { enabled: false},enableMouseTracking: true,events: {
            legendItemClick: function () {
                return false; 
            }
        }}}
    baseConfig.config.series = [{name: 'Booking Sessions Count',data: record,color: '#2563EB'}]
    return(
      <div style={{marginTop: 30}}>
        <Charts 
          config={baseConfig.config}/>
        <Row style={{marginLeft: 0,marginTop: 30,marginBottom: 0}}>
          <Col span={12}>
            <Row type="flex" justify="start">
              <h4 className="sub-heading-title" style={{color: '#6B7280',marginLeft: 5}}>SESSIONS COUNT DISTRIBUTION BY</h4>
            </Row>
          </Col>
          <Col span={12}>
            <Row type="flex" justify="end">
              <h6 style={{color: '#6B7280',fontSize: 14}}>Showing data for <span className="semibold" style={{color: '#475569'}}>{text} </span></h6>
            </Row>  
          </Col>
        </Row>    
        <Row>
          <Col span={24}>
            <Tabs defaultActiveKey="1" >
              <TabPane tab="Workout" key="1">
                {this.renderWorkoutChartTrends(dv,'workout')}
              </TabPane>
              <TabPane tab="Locality" key="2">
                {this.renderWorkoutChartTrends(dv,'locality')}
              </TabPane>
              <TabPane tab="Week day" key="3">
                {this.renderWorkoutChartTrends(dv,'weekday')}
              </TabPane>
            </Tabs>    
          </Col>
        </Row>    
      </div>
    )
  }

  renderEmployeeDistributionChart(text,keys,series){
    let that = this
    let maxBarsToShow = keys.length - 1
    let maxBars = text === "gender" ? 1 : maxBarsToShow
    let showScrollBar = keys.length > 2 ? true : false
    let baseConfig = _.cloneDeep(that.state.baseConfig)
    baseConfig.config.chart.type = 'column'
    baseConfig.config.yAxis.title = {text: "Employee Count"}
    baseConfig.config.xAxis = {categories: keys,
                                min: 0,
                                max: maxBars,
                                scrollbar: {enabled: showScrollBar,
                                            barBackgroundColor: '#e8e8e8',
                                            barBorderColor: '#e8e8e8',
                                            barHeight: '15px',
                                            buttonBackgroundColor: '#ffffff',
                                            buttonBorderColor: '#e8e8e8',
                                            backgroundColor: '#F3F4F6'}
                              } 

    baseConfig.config.series = [{name: 'Employee Count',data: series,color: 'white'}]
    baseConfig.config.plotOptions = {column: {maxPointWidth: 21}}
    return(
      <div style={{marginBottom: 20}}>
        <Card className="health-check-utilization-card" style={{marginBottom: 20}}>
        <Charts 
          filters={this.state.employeeCountOverall.filters} 
          config={baseConfig.config}/>
        </Card>  
      </div>
    )
  }

  renderTable(record){
    let that = this
    const columns = [
                      {
                        title: 'Rank',
                        dataIndex: 'rank',
                        key: 'rank',
                        width: 150,
                        render: (text, record, row) => {
                          if(record.rank === 1){
                            return(<img src={BadgeFirstIcon}/>)
                          }else{
                            return(
                              <span className="semibold">{record.rank}</span> 
                            )
                          }
                        }  
                      },
                      {
                        title: 'Name',
                        dataIndex: 'name',
                        key: 'name',
                        render: (text, record, row) => {
                          return(
                            <span className="semibold">{record.name}</span>
                          )
                        }
                      },
                      {
                        title: 'Sessions',
                        dataIndex: 'sessions',
                        width: 150,
                        key: 'sessions',
                        render: (text, record, row) => {
                          return(
                            <span className="semibold" style={{color: '#2563EB'}}>{record.sessions}</span>
                          )
                        }
                      },
                    ]
    return(
      <div>
        <Table columns={columns} dataSource={record} pagination={{pageSize: 50}} scroll={{y: 500}} />
      </div>
    )
  }

  render () {
    let that = this
    const overviewLoading = this.state.loading
    let remaining_sessions = that.state.data.provided_limit - that.state.data.utilized_limit
    console.log(this.state)
    return(
      <div>
        {(that.state.loading || Object.keys(that.state.data).length === 0 )? <div className="spiner">
          <Spin size="large"/>
        </div> :
        <div>
        <Breadcrumb list={[{ text: 'Overview', link: '/overview' }, { text: 'Gyms and Fitness', link: '#' }]} classes='mb-1' />
        <Row>
          <Col span={12}>
            <Row type="flex" justify="start">
              <a className="flex flex-row w-full mb-2 items-center" style={{marginTop: 10}}onClick={this.renderOverview.bind(this)}><img className="mt-minus-4 chevronBackLink" style={{marginRight: 5}} src={LeftChevronIcon} /> <span className="GoBackLink" >Go Back</span></a>
            </Row>
          </Col>
        </Row>  
        <Row>
          <Col span={12}>
            <Row type="flex" justify="start">
              <h2 className='font-fig-extrabold text-3xl font-medium leading-tight tracking-tight text-gray-900 sm:text-4xl mb-0'>Gyms and Fitness</h2>                
            </Row>
            <Row type="flex" justify="start">              
              <h4 className="semibold" style={{color: '#6B7280',marginTop: 20}}>Remaining sessions <span className="semibold" style={{color: '#475569'}}>{remaining_sessions}</span></h4>
            </Row>
            <Row type="flex" justify="start">              
              <h5 style={{color: '#6B7280'}} className="mt-minus-8">Reach out to <span className="semibold" style={{color: '#2563EB'}}>{sessionStorage.getItem('hr_contact_email')}</span> to topup</h5>
            </Row>
          </Col>
          <Col span={12}>
            <Row type="flex" justify="end">
              <img src={GymImage} alt="wellness" />
            </Row>
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <Row type="flex" justify="start" style={{marginLeft: 0,marginTop: 15}}>
              <h4 className="sub-heading-title" style={{color: '#6B7280',marginTop: 8}}>&nbsp;<span className="semibold" style={{color: '#2563EB'}}>{that.state.data.users_utilized_gyms}</span>&nbsp;Employees booked<span className="semibold" style={{color: '#475569'}}>&nbsp;{that.state.data.utilized_limit}</span>&nbsp;sessions till date</h4>
            </Row>
          </Col>
          <Col span={12}>
            <Row type="flex" justify="end" style={{paddingRight: 0,marginTop: 5}}>
              <h4 className="top-right-delay-label" style={{marginTop: 10}}>Refreshes every <b> 1 hour </b></h4>
            </Row>
          </Col>
        </Row>
        <Card className="health-check-utilization-card" style={{marginBottom: 20,marginTop: 10}}>
          <Row>
            <Col span={12}>
              <h4 style={{color: '#6B7280'}}>Trends is based on the total sessions booked</h4>
            </Col>
            <Col span={12}>
              <Row type="flex" justify="end">
                <Select 
                  defaultValue="last_30_days" 
                  style={{ width: 150, backgroundColor: '#fff' }} 
                  onChange={this.handleChange.bind(this)}
                  >
                  <Option value="last_30_days">Last 30 Days</Option>
                  <Option value="last_12_months">Last 12 Months</Option>
                  <Option value="last_year">Last Year</Option>
                  <Option value="overall">Overall</Option>
                </Select>
              </Row>
            </Col>  
          </Row>  
          {this.renderChartTrends()}  
        </Card>
        <Row type="flex" justify="start" style={{marginLeft: 0,marginTop: 30,marginBottom: 5}}>
          <h4 className="sub-heading-title" style={{color: '#6B7280',marginLeft: 0}}>EMPLOYEE COUNT DISTRIBUTION BY</h4>
        </Row>
        <Row>
          <Col span={24}>
            <Tabs defaultActiveKey="3" >
              <TabPane tab="Age" key="3">
                {this.renderEmployeeDistributionChart("age",that.state.data.age_keys,that.state.data.age_series)}
              </TabPane>
              <TabPane tab="Gender" key="4">
                {this.renderEmployeeDistributionChart("gender",that.state.data.gender_keys,that.state.data.gender_series)}
              </TabPane>
              <TabPane tab="Department" key="5">
                {this.renderEmployeeDistributionChart("departments",that.state.data.department_keys,that.state.data.department_series)}
              </TabPane>
              <TabPane tab="Location" key="6">
                {this.renderEmployeeDistributionChart("locations",that.state.data.location_keys,that.state.data.location_series)}
              </TabPane>
            </Tabs>    
          </Col>
        </Row> 
        <Row type="flex" justify="start" style={{marginLeft: 0,marginTop: 30}}>
          <h4 className="sub-heading-title" style={{color: '#6B7280',marginLeft: 0}}>LEADERBOARD</h4>
        </Row>
        <Row>
          <Col span={24}>
            <Tabs defaultActiveKey="1" >
              <TabPane tab="All" key="1">
                {this.renderTable(that.state.data.leaderboard_all_steps)}
              </TabPane>
              <TabPane tab="This Week" key="2">
                {this.renderTable(that.state.data.leaderboard_this_week)}
              </TabPane>
              <TabPane tab="This Month" key="3">
                {this.renderTable(that.state.data.leaderboard_this_month)}
              </TabPane>
              <TabPane tab="This Year" key="4">
                {this.renderTable(that.state.data.leaderboard_this_year)}
              </TabPane>
            </Tabs>  
          </Col>
        </Row>
        </div>
        }
      </div>  
    )
  } 
}
export default Trends;